import { FaMapMarkedAlt, FaAt } from "react-icons/fa";
import { motion } from "framer-motion";
import { AboutMe } from "../data/about-me-data";

export default function Footer() {
  return (
    <motion.footer
      initial={{ x: "-100%" }}
      animate={{ x: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className="relative px-5 pb-8 [&_h4]:font-medium"
    >
      <div className="flex flex-wrap justify-around pt-5 gap-6 border-t-2 border-portfolio-border [border-top-style:solid] max-[1200px]:flex-col max-[1200px]:items-start max-[1200px]:justify-start">
        <div className="flex flex-col gap-3 sm:max-w-80">
          <h4>Message</h4>
          <p className="text-xs">
            If you like my portfolio, feel free to reach out. I would be happy
            to discuss collaboration opportunities.
          </p>
        </div>

        <div className="flex flex-col gap-3 pb-4">
          <h4>Get in Touch</h4>
          <div className="flex flex-col gap-2 [&>p]:flex [&>p]:items-center [&>p]:gap-3 [&>p]:text-xs [&>p>svg]:text-base [&>p>svg]:text-portfolio-accent">
            <p>
              <FaMapMarkedAlt />
              <span>{AboutMe.Address}</span>
            </p>
            <p>
              <FaAt />
              <span>{AboutMe.Email}</span>
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-portfolio-border [border-top-style:solid] pt-4 text-center text-[11px]">
        <p>
          &#169; All rights reserved. Designed and built by{" "}
          <strong>{AboutMe.FullName}</strong>
        </p>
      </div>
    </motion.footer>
  );
}
